import * as GuardiansV2API from "@/services/api/guardiansv2";
import type {
  AuditableEntityKind,
  AuditableEntityRow,
} from "@/services/api/guardiansv2/types";

export const OBJECT_ID_RE = /^[a-f0-9]{24}$/i;

export type ResolveEntityFn = (
  id: string,
  kinds: AuditableEntityKind[]
) => Promise<AuditableEntityRow[]>;

/** Default resolver for pasted / typed Mongo ObjectIds. */
export async function defaultResolveEntityById(
  id: string,
  kinds: AuditableEntityKind[]
): Promise<AuditableEntityRow[]> {
  const result = await GuardiansV2API.resolveAuditableEntity({ id, kinds });
  return result.entities;
}

/** Split clipboard or input text into ObjectId tokens. */
export function parseObjectIds(text: string): string[] {
  return text
    .split(/[\s,;]+/)
    .map((part) => part.trim())
    .filter((part) => OBJECT_ID_RE.test(part));
}

export function isObjectId(value: string): boolean {
  return OBJECT_ID_RE.test(value.trim());
}
